import React, { useState } from 'react';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import SimpleForm from 'components/SimpleForm';
import SubmitButton from 'components/SubmitButton';
import { withRouter } from 'react-router-dom';
import { compose } from 'recompose';
import { useFirebase } from 'components/Firebase/context';

const PasswordForgetForm = () => {
  const firebase = useFirebase();

  const [email, setEmail] = useState('');
  const [errorText, setErrorText] = useState(null);
  const [successText, setSuccessText] = useState(null);

  const isInvalid = email === '';
  const onSubmit = () => {
    firebase
      .doUserPasswordReset(email)
      .then(() => {
        setEmail('');
        setSuccessText('Your password reset link has been sent!');
        setErrorText(null);
      })
      .catch(err => {
        setSuccessText(null);
        setErrorText(err.message);
      });
  };

  return (
    <SimpleForm title="Forgot Password" errorText={errorText} successText={successText} onSubmit={onSubmit}>
      <FormControl margin="normal" required fullWidth>
        <InputLabel htmlFor="email">Email Address</InputLabel>
        <Input id="email" name="email" value={email} onChange={e => setEmail(e.target.value)} autoComplete="email" />
      </FormControl>
      <SubmitButton disabled={isInvalid}>reset my password</SubmitButton>
    </SimpleForm>
  );
};
export default compose(withRouter)(PasswordForgetForm);
